import getQuoteIdFromUrl from './getQuoteIdFromUrl';

type Window = {
  getQuoteIdUrl: string;
};

const _window = window as unknown as Window;

const updateQuantityToUrl = (url, requestData) => {
  return new Promise((resolve, reject) => {
    getQuoteIdFromUrl(_window.getQuoteIdUrl)
      .then((quoteId) => {
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...requestData, quoteid: quoteId }),
        })
          .then((response) => {
            if (!response.ok) {
              reject(
                `HTTP error! status: ${response.status} after call updateItemQuantityUrl (${url})`,
              );
            }
            return response.json();
          })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(`Response after call updateItemQuantityUrl (${url}): ${error}`);
          });
      })
      .catch((error) => {
        reject(`Response after call updateItemQuantityUrl (${url}): ${error}`);
      });
  });
};

export default updateQuantityToUrl;
